// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* classes for the loading spinner on the review page  */
.loader-container {
  position: absolute;
  left: calc(50% - 40px);
  top: calc(50% - 40px);
}
.loader {
  width: 80px;
  height: 80px;
}
.loader circle {
  fill: transparent;
  stroke: #e1261c;
  stroke-width: 8;                        /* width x .1 */
  stroke-dasharray: 251.33;               /* width x pi */
  transform-origin: 40px 40px 0;          /* width x .5, width x .5, 0 */
  animation: loader 2s linear infinite;
}
@keyframes loader {
  0% {
      transform: rotate(-90deg);
      stroke-dashoffset: 62.83;        /* .25 x pi x width */
  }
  16.67% {
      transform: rotate(27deg);
      stroke-dashoffset: 50.27;        /* .20 x pi x width */
  }
  33.33% {
      transform: rotate(153deg);
      stroke-dashoffset: 75.40;        /* .30 x pi x width */
  }
  58.33% {
      transform: rotate(320deg);
      stroke-dashoffset: 138.23;       /* .55 x pi x width */
  }
  66.67% {
      transform: rotate(385deg);
      stroke-dashoffset: 138.23;       /* .55 x pi x width */
  }
  83.33% {
      transform: rotate(516deg);
      stroke-dashoffset: 113.10;       /* .45 x pi x width */
  }
  100% {
      transform: rotate(630deg);
      stroke-dashoffset: 62.83;        /* .25 x pi x width */
  }
}
`, "",{"version":3,"sources":["webpack://./projects/lossreporting-library/src/lib/confirmation/please-wait/please-wait.component.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe,yBAAyB,eAAe;EACvD,wBAAwB,gBAAgB,eAAe;EACvD,6BAA6B,WAAW,8BAA8B;EACtE,oCAAoC;AACtC;AACA;EACE;MACI,yBAAyB;MACzB,wBAAwB,SAAS,qBAAqB;EAC1D;EACA;MACI,wBAAwB;MACxB,wBAAwB,SAAS,qBAAqB;EAC1D;EACA;MACI,yBAAyB;MACzB,wBAAwB,SAAS,qBAAqB;EAC1D;EACA;MACI,yBAAyB;MACzB,yBAAyB,QAAQ,qBAAqB;EAC1D;EACA;MACI,yBAAyB;MACzB,yBAAyB,QAAQ,qBAAqB;EAC1D;EACA;MACI,yBAAyB;MACzB,yBAAyB,QAAQ,qBAAqB;EAC1D;EACA;MACI,yBAAyB;MACzB,wBAAwB,SAAS,qBAAqB;EAC1D;AACF","sourcesContent":["/* classes for the loading spinner on the review page  */\n.loader-container {\n  position: absolute;\n  left: calc(50% - 40px);\n  top: calc(50% - 40px);\n}\n.loader {\n  width: 80px;\n  height: 80px;\n}\n.loader circle {\n  fill: transparent;\n  stroke: #e1261c;\n  stroke-width: 8;                        /* width x .1 */\n  stroke-dasharray: 251.33;               /* width x pi */\n  transform-origin: 40px 40px 0;          /* width x .5, width x .5, 0 */\n  animation: loader 2s linear infinite;\n}\n@keyframes loader {\n  0% {\n      transform: rotate(-90deg);\n      stroke-dashoffset: 62.83;        /* .25 x pi x width */\n  }\n  16.67% {\n      transform: rotate(27deg);\n      stroke-dashoffset: 50.27;        /* .20 x pi x width */\n  }\n  33.33% {\n      transform: rotate(153deg);\n      stroke-dashoffset: 75.40;        /* .30 x pi x width */\n  }\n  58.33% {\n      transform: rotate(320deg);\n      stroke-dashoffset: 138.23;       /* .55 x pi x width */\n  }\n  66.67% {\n      transform: rotate(385deg);\n      stroke-dashoffset: 138.23;       /* .55 x pi x width */\n  }\n  83.33% {\n      transform: rotate(516deg);\n      stroke-dashoffset: 113.10;       /* .45 x pi x width */\n  }\n  100% {\n      transform: rotate(630deg);\n      stroke-dashoffset: 62.83;        /* .25 x pi x width */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
